



































































































































import Vue from 'vue';
import TextInput from '@/components/TextInput.vue';
import { mapModelLike } from '@/store/util';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { translatedEnumOptions } from '@/i18n';
import { CharacterType } from '@/model';

@Component({
  components: { TextInput },
  computed: {
    ...mapModelLike(
      'personalData', [
        'name',
        'ethnicity',
        'metaType',
        'age',
        'gender',
        'height',
        'weight',
        'reputation',
        'searchWarrantLevel',
        'spentKarma',
        'totalKarma',
        'characterType',
      ],
    ),
  },
})
export default class PersonalDataBox extends Vue {
  static defaultHeight = 6;

  @Prop(Boolean) readonly editMode: boolean | undefined;

  characterTypes = translatedEnumOptions(CharacterType, 'personalData.characterTypes');
}
